import { WsClient } from './WsClient';

export interface WsRequestData {
  doc();
  format();
  getConvRefId();
  urlPath?: string;
}

export abstract class WsRequest {
  data: WsRequestData;
  client: WsClient;
  addHeaders?(headers, svcConfig): void;

  constructor(client: WsClient, data: WsRequestData) {
    this.client = client;
    this.data = data;
  }

  get doc() {
    return this.data.doc();
  }

  get format() {
    return this.data.format();
  }

  get getConvRefId() {
    return this.data.getConvRefId();
  }

  get urlPath() {
    return this.data.urlPath || '';
  }
}
